const mutations = {
	setPoloSelecionado(state, polo) {
		state.poloSelecionado = polo;
	},
	setPolos(state, polos) {
		state.polos = polos;
	},
	setPoloPadrao(state, poloPadrao) {
		state.poloPadrao = poloPadrao;
	}
};

export default mutations;
